import { render, staticRenderFns } from "./DeactivateBrandPopup.vue?vue&type=template&id=5966fe62&scoped=true&"
import script from "./DeactivateBrandPopup.vue?vue&type=script&lang=ts&"
export * from "./DeactivateBrandPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivateBrandPopup.vue?vue&type=style&index=0&id=5966fe62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5966fe62",
  null
  
)

export default component.exports